import * as React from "react";
import { withOpenState, OpenStateInjectedProps } from "ui/common/enhancers/with-open-state";
import { ModalWrapper } from "app/components/modal-wrapper/modal-wrapper";
import { ModalSize } from "app/components/constants";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./case-view-modal.scss";
import { routeConstants } from "app/routes/route-constants";
import { inStartupDashboard } from "app/components/helpers";

interface CaseViewModalProps {
  children?: any;
  favouriteId?: number;
  dashboardType?: number;
  bowtieCaseId?: number;
}

export type CaseViewModalComponentProps = CaseViewModalProps & OpenStateInjectedProps;

export const CaseViewModalComponent = (props: CaseViewModalComponentProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const scrollPositionRef = React.useRef(0);

  React.useEffect(() => {
    if (!props.isOpen) {
      props.open();

      // Save scroll position
      scrollPositionRef.current = window.scrollY;

      // Lock background scroll
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPositionRef.current}px`;
      document.body.style.width = '100%';
    }

    return () => {
      // Clean up styles if unmounted
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, []);

  const getCurrentPath = () => {
    if (props.dashboardType) {
      return routeConstants.dashboardWithFavouriteFor(props.dashboardType, props.favouriteId);
    }
    if (props.bowtieCaseId) {
      return routeConstants.bowtieViewFor(props.bowtieCaseId);
    }
    if (props.favouriteId) {
      return routeConstants.favouriteViewFor(Number(props.favouriteId));
    }
    return routeConstants.startupView;
  };

  const closeModal = () => {
    const currentPath = getCurrentPath();
    searchParams.delete("section");
    const currentSearchParams = inStartupDashboard() ? '' : `?${searchParams.toString()}`;
    props.close();
    navigate(`${currentPath}${currentSearchParams}`);

    // Restore scroll position
    const y = scrollPositionRef.current;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo({ top: y, behavior: 'instant' });
  };

  const modalView = React.useMemo(
    () => (
      <ModalWrapper onClose={closeModal} size={ModalSize.xtraLarge}>
        <div className={styles.caseViewModalContent}>{props.children}</div>
      </ModalWrapper>
    ),
    [props.children]
  );

  return props.isOpen ? (
    <div id="caseViewModal" className={styles.caseViewModal}>
      {modalView}
    </div>
  ) : null;
};

export const CaseViewModal = withOpenState()(CaseViewModalComponent);
